import { useSelector } from 'react-redux';

import timezoneOptions from '@/data/timezones';

const DEFAULT_TIMEZONE = 'Europe/Brussels';

function useUserTimezone() {
	const userTimezone = useSelector(
		state => state.profile.timezone || DEFAULT_TIMEZONE
	);
	return (
		timezoneOptions.find(t => t.value === userTimezone) || {
			label: userTimezone,
			value: userTimezone
		}
	);
}

export default useUserTimezone;
